export class DateFormats {
  static DATE_MONTH_DAY_YEAR = 'MM/DD/YYYY';
  static DATE_DAY_MONTH_YEAR = 'dd/MM/yyyy';
  static DATE_DAY_YEAR_MONTH = 'dd/yyyy/MM';
  static DATE_YEAR_MONTH_DAY = 'YYYY/MM/DD';
  static DATE_YEAR_MONTH_DAY_KABOB = 'YYYY-MM-DD';
  static MONTH_DAY = 'MMM DD';
  static DAY_NAME = 'dddd';
}
